<template>
  <div class="newsList-page">
    <Header ref="Header"
      @onChangLogin="onChangLogin"
      :isLogin="loginShow"
      :setShow="['news']"
    />
    <NavBar ref="NavBar" :tab="5" @onChangLogin="onChangLogin" :isLogin="loginShow" />
    <div class="pageContent flex flex-pack-justify">
      <div class="news">

        <div class="live-loading" v-if="isloadingShow" style="padding: 40% 0 20% 0 ;">
          <van-loading vertical><span class="loadtext">{{ langConfig.txtLang[langConfig.curLang]['LOADING'] }}</span></van-loading>
        </div>
        <!-- 新闻类别 -->
        <div class="newsType" :class="isCeiling?'ceiling_on':''" v-if="newsCategoryList.length > 0">
          <ul class="flex" @mousedown="mousedown" @mouseup="mouseup" @mousemove="mousemove" ref="newsType">
            <li @click="changeType(0)" :class="ListNewsParam.categoryId == 0 ? 'active' : ''">{{ langConfig.news[langConfig.curLang]['ALL'] }}</li>
            <li v-for="(item,index) in newsCategoryList" :key="index" :class="ListNewsParam.categoryId == item.id ? 'active' : ''" @click="changeType(item.id)" :ref="'category_' + item.id">{{item.name}}</li>
          </ul>
        </div>
        <!-- 移动端 -->
        <div v-if="screenWidth < 768">
          <div class="no-data" v-if="mobileNoData == true">
            <img :src="require(`@/assets/images/icon-nodata.png`)" alt="" />
            <span>{{ langConfig.txtLang[langConfig.curLang]['NO_DATA'] }}</span>
          </div>
          <div style="height: 90vh;overflow-y: auto;" v-infinite-scroll="load" infinite-scroll-immediate='false' ref="newsList" >
            <!-- 置顶新闻 -->
            <div class="top-news" v-if="topList.length > 0">
              <div class="news-title">{{ langConfig.news[langConfig.curLang]['TOP_NEWS'] }}</div>
              <!-- <div class="top-news-list">
                <div class="flex">
                  <van-swipe :show-indicators="false" :loop="false" :width="swipeWidth" ref="swiper" :key="Math.random()">
                    <template v-for="(item,index) in topList">
                      <van-swipe-item style="cursor: pointer;" :key="index">
                        <div class="top-news-list-item" @click="toNewsInfo(item)">
                          <div class="top-news-list-img" :ref="'swiperItem_' + index">
                            <img :src="item.thumbnail" />
                            <div class="top-news-list-title">
                              <p>{{ item.title }}</p>
                            </div>
                          </div>
                          <div class="flex flex-align-center top-news-list-accountInfo" v-if="item.hasOwnProperty('author')">
                            <div v-if="item.author.avatar" class="accountImg"><img :src="item.author.avatar"></div>
                            <div class="accountName">{{ item.author.name }}</div>
                          </div>
                        </div>
                      </van-swipe-item>
                    </template>
                  </van-swipe>
                </div>
                <div @click="swipePrev" class="leftBtn"><img src="~@/assets/images/left.png"></div>
                <div @click="swipeNext" class="rightBtn"><img src="~@/assets/images/right.png"></div>
              </div> -->
              <div class="top-news-list">
                <div class="flex top-news-list-box" ref="topNewsList">
                  <div style="margin-right: 8px;" class="top-news-list-item" v-for="(item,index) in topList" :key="index">
                    <router-link :to="toNewsInfo(item)">
                      <div class="top-news-list-img" :ref="'swiperItem_' + index">
                        <img :src="item.thumbnail" />
                        <div class="top-news-list-title">
                          <p>{{ item.title }}</p>
                        </div>
                      </div>
                      <div class="flex flex-align-center top-news-list-accountInfo" v-if="item.hasOwnProperty('author')">
                        <div v-if="item.author.avatar" class="accountImg"><img :src="item.author.avatar"></div>
                        <div class="accountName">{{ item.author.name }}</div>
                      </div>
                    </router-link>
                  </div>
                </div>
                <div  v-show="ishideLeft" v-if="topList.length > 2" @click="swipePrev" class="leftBtn"><img src="~@/assets/images/left.png"></div>
                <div v-show="ishideRight" v-if="topList.length > 2" @click="swipeNext" class="rightBtn"><img src="~@/assets/images/right.png"></div>
              </div>
            </div>
            <!-- 新闻列表 -->
            <div>
              <div class="news-list" v-for="(item,index) in mobileNewsList" :key="index">
                <div class="news-title">{{ weekArr[new Date(item.time * 1000).getDay()] }}, {{ datetimeStr((item.time * 1000),0) }}</div>
                <ul>
                  <li class="flex" v-for="(item1,index1) in item.list" :key="index1">
                    <router-link :to="toNewsInfo(item1)"><div class="news-list-img"><img :src="item1.thumbnail"></div></router-link>
                    <div class="news-list-right">
                      <router-link :to="toNewsInfo(item1)"><div class="news-list-title">{{ item1.title }}</div></router-link>
                      <div class="flex flex-align-center" v-if="item1.hasOwnProperty('author')">
                        <div v-if="item1.author.avatar" class="news-list-accountImg"><img :src="item1.author.avatar"></div>
                        <div class="news-list-accountName">{{ item1.author.name }}</div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              
              <!-- <div class="pagination">
                <el-pagination 
                  background layout="prev, pager, next" :total="pageInfo.total" 
                  prev-text="Previous" next-text="Next" 
                  @current-change="handleCurrentChange"
                />
              </div> -->
            </div>
          </div>
        </div>
        <!-- pc端 -->
        <div v-else>
          <div class="no-data" v-if="PCNoData == true">
            <img :src="require(`@/assets/images/icon-nodata.png`)" alt="" />
            <span>{{ langConfig.txtLang[langConfig.curLang]['NO_DATA'] }}</span>
          </div>
          <!-- 置顶新闻 -->
          <div class="top-news" v-if="topList.length > 0">
            <div class="news-title">{{ langConfig.news[langConfig.curLang]['TOP_NEWS'] }}</div>
            <div class="top-news-list">
              <div class="flex top-news-list-box" ref="topNewsList">
                <div style="margin-right: 8px;" class="top-news-list-item" v-for="(item,index) in topList" :key="index">
                  <router-link :to="toNewsInfo(item)">
                    <div class="top-news-list-img" :ref="'swiperItem_' + index">
                      <img :src="item.thumbnail" />
                      <div class="top-news-list-title">
                        <p>{{ item.title }}</p>
                      </div>
                    </div>
                    <div class="flex flex-align-center top-news-list-accountInfo" v-if="item.hasOwnProperty('author')">
                      <div v-if="item.author.avatar" class="accountImg"><img :src="item.author.avatar"></div>
                      <div class="accountName">{{ item.author.name }}</div>
                    </div>
                  </router-link>
                </div>
              </div>
              <div  v-show="ishideLeft" v-if="topList.length > 2" @click="swipePrev" class="leftBtn"><img src="~@/assets/images/left.png"></div>
              <div v-show="ishideRight" v-if="topList.length > 2" @click="swipeNext" class="rightBtn"><img src="~@/assets/images/right.png"></div>
            </div>
            <!-- <div class="top-news-list">
              <div class="flex">
                <van-swipe :show-indicators="false" :loop="false" :width="swipeWidth" ref="swiper" :key="Math.random()">
                  <template v-for="(item,index) in topList">
                    <van-swipe-item style="cursor: pointer;margin-right: 80px" :key="index" v-if="1">
                      <div class="top-news-list-item" @click="toNewsInfo(item)">
                        <div class="top-news-list-img" :ref="'swiperItem_' + index">
                          <img :src="item.thumbnail" />
                          <div class="top-news-list-title">
                            <p>{{ item.title }}</p>
                          </div>
                        </div>
                        <div class="flex flex-align-center top-news-list-accountInfo" v-if="item.hasOwnProperty('author')">
                          <div v-if="item.author.avatar" class="accountImg"><img :src="item.author.avatar"></div>
                          <div class="accountName">{{ item.author.name }}</div>
                        </div>
                      </div>
                    </van-swipe-item>
                  </template>
                </van-swipe>
              </div>
              <div v-if="topList.length > 2" @click="swipePrev" class="leftBtn"><img src="~@/assets/images/left.png"></div>
              <div v-if="topList.length > 2" @click="swipeNext" class="rightBtn"><img src="~@/assets/images/right.png"></div>
            </div> -->
            
          </div>
          <!-- 新闻列表 -->
          <div>
            <div class="news-list" v-for="(item,index) in PCNewsList" :key="index">
              <div class="news-title">{{ weekArr[new Date(item.time * 1000).getDay()] }}, {{ datetimeStr((item.time * 1000),0) }}</div>
              <ul>
                <li class="flex" v-for="(item1,index1) in item.list" :key="index1">
                  <router-link :to="toNewsInfo(item1)"><div class="news-list-img"><img :src="item1.thumbnail"></div></router-link>
                  <div class="news-list-right">
                    <router-link :to="toNewsInfo(item1)"><div class="news-list-title">{{ item1.title }}</div></router-link>
                    <div class="flex flex-align-center" v-if="item1.hasOwnProperty('author')">
                      <div v-if="item1.author.avatar" class="news-list-accountImg"><img :src="item1.author.avatar"></div>
                      <div class="news-list-accountName">{{ item1.author.name }}</div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            
            <div class="pagination">
              <el-pagination 
                background layout="prev, pager, next" :total="pageInfo.total"
                :hide-on-single-page="true" :current-page.sync="PCPage"
                :prev-text="langConfig.news[langConfig.curLang]['PREVIOUS']" :next-text="langConfig.news[langConfig.curLang]['NEXT']"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="page-right">
        <template v-if="ListAd.length>0">
          <template v-for="(item, index) in ListAd">
            <div class="ad-box" :class="item.flag ? '' : 'ad-no-icon'" v-if="item.siteId == 601" :key="index">
              <router-link :to="'/gdt?gdtUrl=' + item.url" target="_blank" @click.native="adHit(item.id)"><img :src="item.img" /></router-link>
            </div>
          </template>
        </template>
        <template v-if="ListAd.length>0">
          <template v-for="(item, index) in ListAd">
            <div class="ad-box ad-sticky" :class="item.flag ? '' : 'ad-no-icon'" v-if="item.siteId == 602" :key="index">
              <router-link :to="'/gdt?gdtUrl=' + item.url" target="_blank" @click.native="adHit(item.id)"><img :src="item.img" /></router-link>
            </div>
          </template>
        </template>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "@/components/header.vue";
import NavBar from "@/components/navbar.vue";
import Footer from "@/components/footer.vue";

import { mapState, mapMutations, mapActions } from 'vuex';

import { getNewsCategory, getListNews, getListAd, getAdHits, getSEO } from '@/api/api';

export default {
  name: "newsList",
  components: {
    Header,
    NavBar,
    Footer,
  },

  // asyncData ( { store, route } ) {
  //   return  store.dispatch('news/fetchSEO', {
  //     type: 5
  //   })

  //   // return Promise.all([
  //   //   this.getMvUrl(store, route),
  //   //   this.getMvLikedCount(store, route),
  //   //   this.getMvDetail(store, route).then(async () => {
  //   //     await this.getArtistDetail(store, route);
  //   //     await this.getArtistMvList(store, route);
  //   //     await store.dispatch("HistoryMv/addHistoryMv", store.state.WatchMv.mv);
  //   //   }),
  //   //   this.getCommentMvList(store, route),
  //   // ]).then();
  // },

  data() {
    return {
      isloadingShow: true
      ,mobileNoData: false
      ,PCNoData: false
      ,loginShow: false,
      isCeiling: false  //是否吸顶
      ,screenWidth: 0 //屏幕宽度
      // ,swipeWidth: '' //置顶新闻图片尺寸
      ,newsCategoryList: [] //新闻分类
      ,ListNewsParam: {
        categoryId: this.$route.params.categoryId,
        // page: 1,
      }
      ,mobilePage: 1  //移动端分页
      ,PCPage: 1  //PC端分页
      ,topList: []  //置顶新闻列表
      ,mobileNewsList: [] //移动端新闻列
      ,PCNewsList: [] //PC端新闻列
      ,pageInfo: {} //分页详情
      ,weekArr: this.langConfig.txtLang[this.langConfig.curLang]['DAY_WEEK']
      ,isDown: false // 是否按下鼠标
      ,startX: 0 // 鼠标起始位置
      ,typeScrollLeft: 0 // 滚动条位置
      ,ListAd: [] // 广告
      ,ishideLeft: false
      ,ishideRight: true
    }
  },

  methods:{
    
    // loading
    // logdingFlag(){
    //   if(typeof(window) != 'undefined' && this.newsCategoryList.length == 0 && this.topList.length == 0 && this.mobileNewsList.length == 0 && this.PCNewsList.length == 0){
    //     return true;
    //   }
    //   return false;
    // },

    //数据读取-新闻-分类
    async getNewsCategoryData(){
      let param = {
        userToken: '',
      }
      if(typeof window!='undefined'){
        let _userInfo = this.common.getCookie('userInfo');
        if(typeof(_userInfo) != 'undefined' && _userInfo != null){
          _userInfo = JSON.parse(_userInfo);
          param.userToken = _userInfo.token;
        }
      }

      await getNewsCategory(param).then((res) => {
        this.newsCategoryList = res.data.categoryList
        this.$nextTick(() => {
          let typeList_offsetLeft = this.$refs['newsType'].offsetLeft
          let typeList_width = this.$refs['newsType'].offsetWidth
          let checkedType_offsetLeft = this.$refs['category_' + this.$route.params.categoryId]?.[0].offsetLeft
          
          if(checkedType_offsetLeft > typeList_width){
            this.$refs.newsType.scrollLeft = checkedType_offsetLeft - typeList_offsetLeft
          }else{
            this.$refs.newsType.scrollLeft = 0
          }
        })
        
        this.isloadingShow = false
      }).catch((res) => {
        console.error(res)
      })
    },

    // 数据读取-新闻-列表
    async getListNewsData(){
      let obj = {
        userToken: '',
        page: this.screenWidth < 768 ? this.mobilePage : this.PCPage
      }
      
      let param = Object.assign(obj, this.ListNewsParam);
      
      if(typeof window!='undefined'){
        let _userInfo = this.common.getCookie('userInfo');
        if(typeof(_userInfo) != 'undefined' && _userInfo != null){
          _userInfo = JSON.parse(_userInfo);
          param.userToken = _userInfo.token;
        }
      }
      
      await getListNews(param).then((res) => {
        console.log(res.data)
        this.mobileNoData = false
        this.PCNoData = false
        this.pageInfo = res.data.pageInfo
        this.topList = res.data.topList

        let tempPCNewsList = []
        let tempMobileNewsList = JSON.parse(JSON.stringify(this.mobileNewsList))
        
        for (let i = 0; i < res.data.newsList.length; i++) {
          const ele = res.data.newsList[i];
          if(this.screenWidth < 768){
            if(i == 0){
              let tempList = []
              tempList.push(ele)
              tempMobileNewsList.push({time: ele.createTime,list:tempList})
            }else{
              const ele_prev = res.data.newsList[i-1];
              if(this.datetimeStr((ele_prev.createTime * 1000),0) == this.datetimeStr((ele.createTime * 1000),0)){
                tempMobileNewsList[ tempMobileNewsList.length -1 ].list.push(ele)
              }else{
                let tempList = []
                tempList.push(ele)
                tempMobileNewsList.push({time: ele.createTime,list:tempList})
              }
            }
          }else{
            if(i == 0){
              let tempList = []
              tempList.push(ele)
              tempPCNewsList.push({time: ele.createTime,list:tempList})
            }else{
              const ele_prev = res.data.newsList[i-1];
              if(this.datetimeStr((ele_prev.createTime * 1000),0) == this.datetimeStr((ele.createTime * 1000),0)){
                tempPCNewsList[ tempPCNewsList.length -1 ].list.push(ele)
              }else{
                let tempList = []
                tempList.push(ele)
                tempPCNewsList.push({time: ele.createTime,list:tempList})
              }
            }
          }
        }
        
        // res.data.newsList.forEach((ele,index) => {
        //   if(this.screenWidth < 768){
        //     // 处理移动端
        //     let MobileObj = tempMobileNewsList.find(item => this.datetimeStr((item.time * 1000),0) == this.datetimeStr((ele.createTime * 1000),0))
        //     if(MobileObj){
        //       MobileObj.list.push(ele)
        //     }else{
        //       let tempList = []
        //       tempList.push(ele)
        //       tempMobileNewsList.push({time: ele.createTime,list:tempList})
        //     }
        //   }else{
        //     // 处理pc端数据
        //     let PCObj = tempPCNewsList.find(item => this.datetimeStr((item.time * 1000),0) == this.datetimeStr((ele.createTime * 1000),0))
        //     if(PCObj){
        //       PCObj.list.push(ele)
        //     }else{
        //       let tempList = []
        //       tempList.push(ele)
        //       tempPCNewsList.push({time: ele.createTime,list:tempList})
        //     }
        //   }
        // });

        if(this.screenWidth < 768){
          if(this.mobilePage == 1){
            this.PCNewsList = JSON.parse(JSON.stringify(tempMobileNewsList))
          }
          this.mobileNewsList = JSON.parse(JSON.stringify(tempMobileNewsList))
        }else{
          if(this.PCPage == 1 && this.mobilePage == 1){
            this.mobileNewsList = JSON.parse(JSON.stringify(tempPCNewsList))
          }
          this.PCNewsList = JSON.parse(JSON.stringify(tempPCNewsList))
        }

        this.isloadingShow = false
        if(res.data.topList.length == 0 && (this.mobileNewsList.length == 0 || this.PCNewsList.length == 0)){
          this.mobileNoData = true
          this.PCNoData = true
        }
      }).catch((res) => {
        console.error(res)
      })
    },

    // 获取广告
    async getListAdData(){
      let param = {
        pageId: 6,
        userToken: '',
      }

      let _userInfo = this.common.getCookie('userInfo');
				
      if(typeof(_userInfo) != 'undefined' && _userInfo != null){
        _userInfo = JSON.parse(_userInfo);
        param.userToken = _userInfo.token;
      }

      await getListAd(param).then((res) => {
        console.log(res.data)
        this.ListAd = res.data.webAds
      })
    },

    //时间转换
    datetimeStr(str, type){
      var date = new Date(parseInt(str));
      var YYYY = date.getFullYear();
      var year = date.getYear()
      var year = year < 2000 ? year + 1900 : year
      var YY = year.toString().substr(2, 2);
      var MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      var dd = date.getDate();
      dd = dd < 10 ? "0" + dd : dd;
      var Bd = date.getDate();
      Bd = Bd *1;
      var HH = date.getHours();
      HH = HH < 10 ? "0" + HH : HH;
      var HD = date.getHours();
      HD = HD*1;
      var mm = date.getMinutes();
      mm = mm < 10 ? "0" + mm : mm;
      var ss = date.getSeconds();
      ss = ss < 10 ? "0" + ss : ss;

      var formal = [
      "dd/MM/YYYY",
      ];

      if(this.langConfig.curLang == 'kr'){
        formal = ["YYYY-MM-dd"];
      }

      return formal[type]
      .replace("YYYY", YYYY)
      .replace("YY", YY)
      .replace("MM", MM)
      .replace("dd", dd)
      .replace("HH", HH)
      .replace("mm", mm)
      .replace("ss", ss)
      .replace("Bd", Bd)
      .replace("HD", HD);
    },
    //切换分类
    changeType(id){
      if(this.ListNewsParam.categoryId == id){
        return
      }
      this.$router.push(`/news/${id}`);

      this.ListNewsParam.categoryId = id

      this.PCPage = 1
      this.mobilePage = 1
      

      this.mobileNewsList = []
      this.PCNewsList = []

      let top = document.body.scrollTop || document.documentElement.scrollTop;
      const timeTop = setInterval(() => {
        top -= 50;
        document.body.scrollTop = top;
        document.documentElement.scrollTop = top;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
    // 分页
    handleCurrentChange(val){
      this.PCPage = val
    },
    // 详情
    toNewsInfo(item){
      let title = item.title.toLocaleLowerCase()
      
      // let a = '1:2：3"4“5”6\'7？8' + "'s    9" + '?'
      let Exp=/[\:\：\“\”\"\‘\’\'\?\？\'s]/g;
      title = title.replace(Exp,"")
      title = title.replace(/ /g, '-')
      // this.$router.push(`/newsInfo/${item.id}/${title}`);
      return `/newsInfo/${item.id}/${title}`
    },
    // 滚动加载
    load(){
      console.log('111')
      if((this.$refs.newsList.scrollTop || this.$refs.newsList.scrollTop) != 0){
        this.mobilePage = this.mobilePage + 1
      }
    },
    //获取滚动条高度
    handleScroll() {
      if(typeof window!='undefined'){
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        let Header= (this.$refs.Header?this.$refs.Header.$el.clientHeight*1:null);
        let NavBar= (this.$refs.NavBar?this.$refs.NavBar.$el.clientHeight*1:null);
        if(!Header){
          return;
        }
        
        let dif_H= scrollTop-Header-NavBar;
        this.isCeiling=(dif_H>0?true:false);
      }
    },
    //获取屏幕宽度
    handleResize() {
      if (typeof window != "undefined") {
        this.screenWidth = window.innerWidth;
      }
      // this.$nextTick(() =>{
      //   setTimeout(() =>{
      //     if(this.$refs['swiperItem_1']){
      //       let width = this.$refs['swiperItem_1'] ? this.$refs['swiperItem_1'][0].offsetWidth: this.swipeWidth
      //       this.$set(this,'swipeWidth',width)
      //     }
      //   },400)
      // })
    },

    // 上一页
    swipePrev(){
      let scrollLeft = this.$refs.topNewsList.scrollLeft
      let scrollWidth = this.$refs.topNewsList.scrollWidth
      let clientWidth = this.$refs.topNewsList.clientWidth
      let swiperItem_clientWidth = this.$refs.swiperItem_1[0].clientWidth

      this.$set(this.$refs.topNewsList,'scrollLeft',scrollLeft - swiperItem_clientWidth)

      this.ishideRight = true
      if(scrollLeft - swiperItem_clientWidth < 0){
        this.ishideLeft = false
      }
    },
    // 下一页
    swipeNext(){
      let scrollLeft = this.$refs.topNewsList.scrollLeft
      let scrollWidth = this.$refs.topNewsList.scrollWidth
      let clientWidth = this.$refs.topNewsList.clientWidth
      let swiperItem_clientWidth = this.$refs.swiperItem_1[0].clientWidth

      this.$set(this.$refs.topNewsList,'scrollLeft',scrollLeft + swiperItem_clientWidth)

      this.ishideLeft = true
      if(clientWidth + swiperItem_clientWidth + scrollLeft > scrollWidth){
        this.ishideRight = false
      }
    },

    /* 分类拖动-start */
    mousedown(event){
      this.isDown = true;
      this.startX = event.pageX - this.$refs.newsType.offsetLeft
      this.typeScrollLeft = this.$refs.newsType.scrollLeft
    },
    mouseup(event){
      this.isDown = false
    },
    mousemove(event){
      if (!this.isDown) return
      event.preventDefault();
      const x = event.pageX - this.$refs.newsType.offsetLeft;
      const walk = (x - this.startX) * 2; // 滑动距离
      this.$refs.newsType.scrollLeft = this.typeScrollLeft - walk;
    },
    /* 分类拖动-end */

    // 点击广告
    adHit(id){
      let _id = id;
      let _param = {
        id: _id
      }
      getAdHits(_param);
    },

    onChangLogin(_val) {
      console.log(_val)
      if (_val.loginShow || _val) {
        this.loginShow = true;
      } else {
        this.loginShow = false;
      }
    },

  },
  mounted(){

    // 监听body滚动事件/屏幕宽度事件监听器
    if(typeof window!='undefined'){
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener("resize", this.handleResize);
    }
    // if(this.$refs['swiperItem_1']){
    //   this.$set(this,'swipeWidth',this.$refs['swiperItem_1'][0].offsetWidth)
    // }
    // this.$set(this,'swipeWidth',407)
  },
  beforeDestroy() {
    // 在组件销毁前移除滚动事件监听器/屏幕宽度事件监听器
    if(typeof window!='undefined'){
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener("resize", this.handleResize);
    }
  },
  created(){
    if(typeof(window) != 'undefined'){
      
      getSEO({ //SEO
        type: 5
      }).then((res) => {
        let _data = JSON.parse(JSON.stringify(res.data));
        document.title = _data.title;
        document.keywords = _data.keywords;
        document.description = _data.description;
      }).catch((res) => {
        console.error(res)
      })

      this.handleResize();
      this.getNewsCategoryData();
      this.getListNewsData();
      this.handleScroll();
      this.getListAdData()
    }


    // this.handleResize();
    // this.getNewsCategoryData();
    // this.getListNewsData();
    // this.handleScroll();
    // this.getListAdData()
  },
  computed: {
    ...mapState('news', ['SEO']),
    
    changeData() {
      const a = this.ListNewsParam.categoryId
      const b = this.mobilePage
      const c = this.PCPage
      return {a, b, c}
    }
  },
  watch: {
    changeData: {
      deep: true,
      handler: function () {
        console.log('1456')
        this.getListNewsData()
      },
    },
  }
}
</script>
<style lang="less">
.newsList-page{
  .pageContent{
    max-width: 1200px;
    margin: 0 auto;
    min-height: calc(100vh - 518px);
    .news{
      width: 976px;
      padding: 16px 8px 0 8px;
      box-sizing: border-box;
      background: @color_FFF;
      .newsType{
        padding-bottom: 16px;
        margin-bottom: 16px;
        border-bottom: 1px solid @color_F0F0F0;
        ul{
          overflow-x: auto;
          white-space: nowrap;
          user-select: none;
          li{
            border-radius: 4px;
            border: 1px solid @color_BFBFBF;
            padding: 0 16px;
            margin-right: 8px;
            font-family: @font_family_SF_Pro_Display;
            font-size: 14px;
            line-height: 22px;
            cursor: pointer;
            white-space: nowrap;
          }
          li.active{
            background: @color_FF6915;
            border: 1px solid @color_FF6915;
            color: @color_FFF;
          }
          &::-webkit-scrollbar {
            width: 0rem; display: none!important;
          }
        }
      }
      .news-title{
        font-family: @font_family_SF_Pro_Display;
        color: @color_000;
        font-size: 16px;
        font-weight: bold;
        padding-left: 24px;
        position: relative;
        line-height: 19px;
        margin-bottom: 16px;
      }
      .news-title::after{
        display: block;
        content: '';
        position: absolute;
        left: 8px;
        top: 50%;
        margin-top: -4px;
        width: 8px;
        height: 8px;
        border-radius: 2px;
        background: @color_FF6915;
      }
      .top-news{
        .top-news-list{
          position: relative;
          .leftBtn{
            opacity: 0.5;
            padding: 24px 0;
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -50px;
            cursor: pointer;
            font-size: 0;
            width: 48px;
            height: 96px;
            img{
              display: none;
              width: 100%;
              height: 100%;
            }
          }
          .leftBtn:hover{
            background: @color_000;
            opacity: 0.5;
            padding: 24px 0;
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -50px;
            cursor: pointer;
            font-size: 0;
            width: 48px;
            height: 96px;
            img{
              display: block;
              width: 100%;
              height: 100%;
            }
          }
          .rightBtn{
            opacity: 0.5;
            padding: 24px 0;
            position: absolute;
            right: 0;
            top: 50%;
            margin-top: -50px;
            cursor: pointer;
            font-size: 0;
            width: 48px;
            height: 96px;
            img{
              display: none;
              width: 100%;
              height: 100%;
            }
          }
          .rightBtn:hover{
            background: @color_000;
            opacity: 0.5;
            padding: 24px 0;
            position: absolute;
            right: 0;
            top: 50%;
            margin-top: -50px;
            cursor: pointer;
            font-size: 0;
            width: 48px;
            height: 96px;
            img{
              display: block;
              width: 100%;
              height: 100%;
            }
          }
          .top-news-list-box{
            overflow: auto;
            scroll-behavior: smooth;
            // .van-swipe-item{
            //   margin-right: 8px!important;
            // }
            .top-news-list-item{
              margin-right: 8px;
              .top-news-list-img{
                width: 407px;
                height: 230px;
                font-size: 0;
                position: relative;
                object-fit: cover;
                overflow: hidden;
                cursor: pointer;
                img{
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
                img:hover{
                  transform: scaleX(1.1) scaleY(1.1);
                  transition: all .2s;
                }
                .top-news-list-title{
                  background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 100%);
                  width: 407px;
                  height: 115px;
                  padding: 48px 20px 10px 20px;
                  position: absolute;
                  bottom: 0;
                  p{
                    color: @color_FFF;
                    font-family: @font_family_SF_Pro_Display;
                    font-size: 16px;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                  }
                }
              }
              .top-news-list-accountInfo{
                background: @color_F5F5F5;
                width: 407px;
                padding: 8px;
                .accountImg{
                  width: 24px;
                  height: 24px;
                  font-size: 0;
                  margin-right: 8px;
                  object-fit: cover;
                  img{
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    object-fit: cover;
                  }
                }
                .accountName{
                  font-size: 14px;
                  font-family: @font_family_SF_Pro_Display;
                  color: @color_000;
                }
              }
            }
          }
          .top-news-list-box::-webkit-scrollbar {
            display: none;
          }
        }
      }
      .news-list{
        .news-title{
          margin: 24px 0;
        }
        li{
          margin-bottom: 16px;
          margin-left: 16px;
          .news-list-img{
            width: 220px;
            height: 165px;
            font-size: 0;
            margin-right: 16px;
            cursor: pointer;
            object-fit: cover;
            overflow: hidden;
            // &:hover{
            //   width: 230px;
            //   height: 175px;
            // }
            img{
              width: 220px;
              height: 165px;
              object-fit: cover;
            }
            img:hover{
              transform: scaleX(1.1) scaleY(1.1);
              transition: all .2s;
            }
          }
          .news-list-right{
            width: 590px;
            .news-list-title{
              cursor: pointer;
              font-size: 18px;
              font-family: @font_family_SF_Pro_Display;
              color: @color_000;
              font-weight: bold;
              line-height: 26px;
              height: 78px;
              margin-bottom: 47px;
              margin-top: 8px;
              text-overflow: -o-ellipsis-lastline;  
              overflow: hidden;  
              text-overflow: ellipsis;  
              display: -webkit-box;  
              -webkit-line-clamp: 3;  
              -webkit-box-orient: vertical;  
            }
            .news-list-accountImg{
              width: 24px;
              height: 24px;
              margin-right: 8px;
              font-size: 0;
              object-fit: cover;
              img{
                width: 100%;
                height: 100%;
                border-radius: 50%;
                object-fit: cover;
              }
            }
            .news-list-accountName{
              font-size: 14px;
              font-family: @font_family_SF_Pro_Display;
              color: @color_000;
            }
          }
        }
      }
      .pagination{
        text-align: center;
        margin: 48px 0;
        .el-pagination.is-background .btn-next, 
        .el-pagination.is-background .btn-prev, 
        .el-pagination.is-background .el-pager li{
          background: @color_FFF;
          border: 1px solid @color_D9D9D9;
          border-radius: 4px;
          font-size: 14px;
          font-family: @font_family_SF_Pro_Display;
          color: @color_434343;
          padding: 0 8px;
        }
        .el-pager li,.el-pagination span:not([class*=suffix]){
          line-height: 26px!important;
        }
        .el-pagination button:hover,
        .el-pager li:hover,
        .el-pager li.active{
          color: @color_FFF!important;
          background: @color_FF6915!important;
          border: 1px solid @color_FF6915!important;
        }
      }
      .no-data {
        padding: 10% 0;
        img {
          display: block;
          width: 166px;
          height: 161px;
          margin: 40px auto 32px;
        }
        span {
          font-family: @font_family_SF_Pro_Display;
          font-size: 18px;
          color: #b9bbce;
          text-align: center;display: block;
          margin-bottom: 40px;
        }
      }
    }
    .page-right{
      width:216px;
      padding-top: 16px;
      .ad-box{
        border-radius: 4px;
        overflow: hidden;
        position: relative;
        &::before{
            content: 'AD';
            padding:2px 6px;
            font-size:12px;
            color:@color_FFF;
            border-radius: 0 0 8px 0;
            background-color: rgba(0,0,0,0.7);
            position:absolute;
            top:0;
            left:0;
        }
        a{
            display: block;
            cursor: pointer;
        }
        img{
            width: 100%;
            height: 100%;
            border-radius: 4px;
        }
      }
      .ad-no-icon{
          &::before{
              display: none;
          }
      }
      .ad-sticky{
          position:sticky;
          top: 0;
          z-index: 51;
      }
    }
  }
}
@media screen and (min-width: 976px) and (max-width: 1026px){
  .newsList-page{
    .pageContent{
      .news{
        margin: 0 auto;
        .top-news{
          .top-news-list{
            width: 100%;
            overflow: hidden;
          }
        }
        .news-list{
          li{
            .news-list-right{
              width: auto;
              flex: 1;
              margin-right: 102px;
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 751px) and (max-width: 977px){
  .newsList-page{
    .pageContent{
      width: 100vw;
      .news{
        width: auto;
        padding: 16px 8px 0 8px;
        .top-news{
          .top-news-list{
            width: calc(100vw - 16px);
            overflow: hidden;
          }
        }
        .news-list{
          li{
            .news-list-right{
              width: auto;
              flex: 1;
              margin-right: 102px;
            }
          }
        }
        .no-data {
          img {
            width: 1.66rem;
            height: 1.61rem;
            margin: 0.40rem auto 0.1rem;
          }
          span {
            font-size: 0.18rem;
            margin-bottom: 0.40rem;
          }
        }
      }
    }
  }
}
/* phone */
@media screen and (max-width: 767px) {
  .newsList-page{
    .pageContent{
      width: 100vw;
      min-width: 100vw;
      .news{
        padding: .08rem 0 .16rem 0;
        width: 100vw;
        min-width: 100vw;
        .ceiling_on{
          padding-top: .08rem;
          position: fixed;
          top: 0;
          left: 0;
          z-index: 10;
          background: @color_FFF;
          width: 100vw;
        }
        .newsType{
          margin-left: 0;
          margin-right: 0;
          padding-left: .12rem;
          padding-right: .12rem;
          width: 100vw;
          border-bottom: none;
          padding-bottom: .08rem;
          margin-bottom: .035rem;
          ul{
            padding-bottom: 0;
            overflow-x: scroll;
            white-space: nowrap;
            li{ 
              border-radius: .04rem;
              border: .01rem solid @color_BFBFBF;
              padding: 0 .16rem;
              margin-right: .1rem;
              font-size: .14rem;
              line-height: .24rem;
            }
          }
        }
        .news-title{
          font-size: .14rem;
          padding-left: .16rem;
          line-height: .17rem;
        }
        .news-title::after{
          width: .08rem;
          height: .08rem;
          left: 0;
          top: .05rem;
          margin-top: 0;
          border-radius: .02rem;
        }
        .top-news{
          padding: 0;
          .news-title{
            margin-left: .12rem;
          }
          .top-news-list{
            width: 100vw;
            padding-left: .12rem;
            .leftBtn{
              opacity: 0.5;
              background: @color_000;
              padding: .18rem 0;
              position: absolute;
              left: 0;
              top: 50%;
              margin-top: -.3rem;
              cursor: pointer;
              font-size: 0;
              width: .24rem;
              height: .6rem;
              img{
                display: block;
                width: 100%;
                height: 100%;
              }
            }
            .rightBtn{
              opacity: 0.5;
              background: @color_000;
              padding: .18rem 0;
              position: absolute;
              right: 0;
              top: 50%;
              margin-top: -.3rem;
              cursor: pointer;
              font-size: 0;
              width: .24rem;
              height: .6rem;
              img{
                display: block;
                width: 100%;
                height: 100%;
              }
            }
            // .van-swipe-item{
            //   margin-right: .04rem!important;
            // }
            .top-news-list-box{
              overflow: auto;
              scroll-behavior: smooth;
              .top-news-list-item{
                margin-right: .04rem;
                .top-news-list-img{
                  width: 2.18rem;
                  height: 1.23rem;
                  .top-news-list-title{
                    width: 2.18rem;
                    height: .61rem;
                    padding: .19rem .08rem .08rem .08rem;
                    p{
                      -webkit-line-clamp: 2;
                      font-size: .14rem;
                    }
                  }
                }
                .top-news-list-accountInfo{
                  width: 2.18rem;
                  padding: .04rem .08rem;
                  .accountImg{
                    width: .16rem;
                    height: .16rem;
                  }
                  .accountName{
                    font-size: .12rem;
                  }
                }
              }
            }
          }
        }
        .news-list{
          padding: 0 .12rem;
          .news-title{
            margin: .115rem 0 .115rem 0;
          }
          li{
            margin-left: 0;
            margin-bottom: .08rem;
            .news-list-img{
              width: 1.17rem;
              height: .88rem;
              margin-right: .08rem;
            }
            .news-list-right{
              width: 2.26rem;
              .news-list-title{
                margin-top: 0;
                line-height: .18rem;
                font-size: .14rem;
                margin-bottom: .14rem;
                height: .54rem;
              }
              .news-list-accountImg{
                width: .16rem;
                height: .16rem;
                margin-right: .04rem;
              }
              .news-list-accountName{
                font-size: .12rem;
              }
            }
          }
        }
        .pagination{
          display: none;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// ./src/views/news/list.vue